<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center">
            <div class="layout__item u-4/5-desk">
                <wizard-steps :step="4" />

                <div class="product">
                    <div class="product__title">
                        <h2 class="confirmation-title beta | u-margin-bottom-narrow">{{ trans('order.success') }}</h2>
                    </div>
                    <page-text :pageText="getPageTextByName('order_confirmation_text')" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { pageLoadingStatusMixin } from 'relapp-loading';
import { apiMixin } from 'relapp-api';
import { orderPageMixin } from 'relapp-register';

import PageText from '@/components/PageText.vue';
import WizardSteps from '@/components/WizardSteps.vue';

export default {
    components: {
        PageText,
        WizardSteps
    },
    mixins: [apiMixin, pageLoadingStatusMixin, orderPageMixin],
    props: {},
    metaInfo: {
        title: trans('page.order.confirmation')
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.finishLoading();
    },
    computed: {
        ...mapGetters({
            getPageTextByName: 'pageTexts/pageTextByName'
        })
    }
};
</script>
